import { render, staticRenderFns } from "./OutboundFlight.vue?vue&type=template&id=90b42768"
import script from "./OutboundFlight.vue?vue&type=script&lang=js"
export * from "./OutboundFlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports